import React from 'react';

import styles from './Icon.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCoffee,
  faBars,
  faCheckCircle,
  faCircle,
  faTimesCircle,
  faVideo,
  faEdit,
  faTrash,
  faTrashAlt,
  faChevronRight,
  faChevronLeft,
  faQuestionCircle,
  faTimes,
  faExclamation,
  faAward,
  faDownload,
  faPrint,
} from '@fortawesome/free-solid-svg-icons';

function Icon(props) {
  const { icon, className = '', onClick, testId } = props;
  library.add(
    faCoffee,
    faBars,
    faCheckCircle,
    faCircle,
    faTimesCircle,
    faVideo,
    faEdit,
    faTrash,
    faTrashAlt,
    faChevronRight,
    faChevronLeft,
    faQuestionCircle,
    faTimes,
    faExclamation,
    faAward,
    faDownload,
    faPrint
  );

  function handleIconClick() {
    onClick && onClick();
  }

  return (
    <div
      className={`${styles.Icon} ${
        onClick ? styles.Icon__clickable : ''
      } ${className}`}
      onClick={handleIconClick}
      data-testid={testId}
    >
      <FontAwesomeIcon icon={icon} />
    </div>
  );
}

export default Icon;
